import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import formatGBP from '../../../utils/formatGBP.js';
import { checkIsApplePayExpressCheckout } from '../../../utils/paymentMethod.js';
import { orderTotals, orderTotalsContent } from '../styles.js';
var StubbedOrderTotals = function StubbedOrderTotals(_ref) {
  var amount = _ref.amount,
    paymentMethodType = _ref.paymentMethodType,
    shippingAmount = _ref.shippingAmount;
  var _useMemo = useMemo(function () {
      return {
        isApplePayExpressCheckout: checkIsApplePayExpressCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isApplePayExpressCheckout = _useMemo.isApplePayExpressCheckout;
  return jsxs("div", {
    style: orderTotals,
    children: [isApplePayExpressCheckout && jsxs("div", {
      style: orderTotalsContent,
      children: ["Delivery charge:", ' ', jsx("div", {
        children: shippingAmount ? formatGBP(shippingAmount) : 'FREE'
      })]
    }), jsxs("strong", {
      style: orderTotalsContent,
      children: ["Order total:", ' ', jsx("div", {
        children: amount ? formatGBP(amount + (shippingAmount !== null && shippingAmount !== void 0 ? shippingAmount : 0)) : '£0.00'
      })]
    })]
  });
};
export { StubbedOrderTotals as default };